import MascarasContainer from './containers/mascaras-container';
export default MascarasContainer;